import PageMain from '../../components/Navigation/PageMain/PageMain';
import UserEmailSettings from '../../components/Settings/UserEmailSettings/UserEmailSettings';

export default function UserEmailSettingsPage() {
    return (
        <PageMain pageTitle="User Email Settings" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <UserEmailSettings />
                </div>
            </div>
        </PageMain>
    );
}
